import { render, staticRenderFns } from "./postal.vue?vue&type=template&id=0712db19"
import script from "./postal.vue?vue&type=script&lang=js"
export * from "./postal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports